import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui-kit/card';
import { Folder } from 'lucide-react';
import { Skeleton } from '@/components/ui-kit/skeleton';
import React from "react";

type NoFoldersProps = {
  action?: React.ReactNode;
  isLoading?: boolean;
};

export const NoFolders = ({ action, isLoading = false }: NoFoldersProps) => {
  const { t } = useTranslation();
  if (isLoading) {
    return (
      <Card className="border-none p-0 shadow-none">
        <CardContent className="flex flex-col items-center justify-center py-12">
          <Skeleton className="mb-6 h-20 w-20 rounded-full" />
          <Skeleton className="mb-2 h-7 w-40" />
          <Skeleton className="mb-2 h-5 w-80" />
          <Skeleton className="mb-8 h-5 w-72" />
          <Skeleton className="h-10 w-28 rounded-md" />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border-none p-0 shadow-none">
      <CardContent className="flex flex-col items-center justify-center py-12">
        <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-muted">
          <Folder className="h-10 w-10 text-muted-foreground" />
        </div>

        <h3 className="mb-2 text-xl font-semibold">{t('NO_FOLDERS_YET')}</h3>

        <p className="mb-8 text-center text-base leading-relaxed text-muted-foreground">
          {t('NO_FOLDERS_DESCRIPTION')}
        </p>

        {action && action}
      </CardContent>
    </Card>
  );
};
